module.exports = __webpack_public_path__ + "img/sub21.fd8cc893.jpg";